<div class="booking-summary-ticket" [id]="id" [ngClass]="{ banner }">
  <span class="tag" *ngIf="banner">{{ banner | i18next }}</span>
  <div class="inner">
    <div class="top">
      <span class="number">{{ count }} X</span>
      <p class="type">
        <i
          class="fa fa-ticket"
          aria-hidden="true"
          [ngClass]="{ hide: isTicketIconHidden }"
        ></i>
        {{ title }}
      </p>
      <button
        type="button"
        aria-label="info"
        class="info"
        (click)="handleInfoClicked()"
      >
        <i class="fa fa-info" aria-hidden="true"></i>
      </button>
    </div>
    <p class="desc">{{ translatedSubtitle }}</p>
  </div>
  <div class="bottom">
    <p class="price">{{ price | currency }}</p>
  </div>
</div>
